export const CLEAR_PLATFORM_SEARCH_INPUT_VALUE =
  'CLEAR_PLATFORM_SEARCH_INPUT_VALUE';
export const PLATFORM_SEARCH = 'PLATFORM_SEARCH';
export const ACTIVE_BLOG = 'ACTIVE_BLOG';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';